module.exports = __webpack_public_path__ + "static/media/Fem.89620420.PNG";